import { ImpressionTracker, PATHS } from '@belong/common';
import { Button, Link, Text } from '@belong/ui';
import type {
  ButtonSize as Size,
  ButtonPartialResponsiveSize as PartialResponsiveSize,
} from '@belong/ui';
import clsx from 'clsx';
import ErrorMessageBubble, {
  ERROR_STATES,
} from 'src/features/homeowners-landlord-insurance-flow/components/error-message-bubble/ErrorMessageBubble';
import css from './modal-contact-us-bottom.module.css';
import { STRINGS } from './strings';

type ModalContactUsBottomProps = {
  onCtaClick: () => void;
  cta: string;
  disabled?: boolean;
  ctaSize?: Size | PartialResponsiveSize;
  hasError?: boolean;
  errorMessage?: string;
  showCta?: boolean;
  id?: string;
};

export function ModalContactUsBottom({
  onCtaClick,
  cta,
  disabled = false,
  ctaSize = 'default',
  hasError = false,
  errorMessage = "Let's complete all required fields",
  showCta = true,
  id,
}: ModalContactUsBottomProps) {
  return (
    <>
      <div
        className={clsx(
          'px-2sm md:mt-2xl md:border-dark-gray md:bg-light-gray md:p-md flex w-full flex-col-reverse md:flex-row md:justify-between md:border-0 md:border-t md:border-solid',
          css.wrapper,
        )}
      >
        <div className="my-sm flex items-center justify-center md:my-0 md:justify-start">
          <Text className="mr-xs md:mr-sm">{STRINGS.questions_concerns}</Text>
          <Link href={PATHS.SUPPORT}>{STRINGS.lets_talk}</Link>
        </div>
        <div className="flex justify-end md:pb-0">
          {showCta && (
            <>
              {hasError && (
                <ErrorMessageBubble
                  showErrorMessageBubble={ERROR_STATES.SHOW_ERROR_MESSAGE}
                  bottomPositionMobile="130px"
                  errorMessage={errorMessage}
                  mobileFixed={false}
                />
              )}
              {id ? (
                <ImpressionTracker section={id}>
                  <div id={id} className="w-full">
                    <Button
                      id={id}
                      onClick={onCtaClick}
                      disabled={disabled}
                      size={ctaSize}
                      className="px-2sm"
                    >
                      {cta}
                    </Button>
                  </div>
                </ImpressionTracker>
              ) : (
                <Button
                  onClick={onCtaClick}
                  disabled={disabled}
                  size={ctaSize}
                  className="px-2sm"
                >
                  {cta}
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
